const getters = {
    invoices: (state) => state.invoices,
    invoiceId: (state) =>state.invoiceId,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;